import React from 'react'

export const Las = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="143.395"
    height="22.149"
    viewBox="0 0 143.395 22.149"
  >
    <g
      id="Group_416"
      data-name="Group 416"
      transform="translate(630.707 -30.822)"
    >
      <path
        id="Path_865"
        data-name="Path 865"
        d="M-563.108,51.084a.308.308,0,0,0,.317.212l2.325-.37.017,0a.289.289,0,0,0,.247-.282,4.756,4.756,0,0,1,4.053-4.685,42.67,42.67,0,0,1,10.232.208l6.424.853,6.446.582,6.5.316,6.5.053,6.551-.158a16.222,16.222,0,0,1,12.1,4.283,4.908,4.908,0,0,0,4.035.332,49.7,49.7,0,0,0,9.651-13.31,2.314,2.314,0,0,0-1.277-2.822l-3.275-1.11-3.381-.9-3.381-.687-3.434-.422-8.982-.793-8.981-.634-9.034-.422-9.034-.212-9.034-.052-9.034.1-12.1.317-12.045.529-12.1.686-12.046.846-8.823.792-8.769,1-8.031,1.268a26.157,26.157,0,0,0,10.783,6.943l3.534,1.034,3.646.793,3.592.634,3.7.475,3.7.317,3.645.106,30.536.687-.011-.042a1.611,1.611,0,0,1,1.538-1.068A1.612,1.612,0,0,1-564.3,47.6Z"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_866"
        data-name="Path 866"
        d="M-564.323,47.6-568.509,36a5.207,5.207,0,0,0-2.957-3.447"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_867"
        data-name="Path 867"
        d="M-552.859,41.733h-2.483l-.211.053-.159.053-.158.159-.159.106-.106.158-.053.211-.053.158v.211"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_539"
        data-name="Line 539"
        x2="2.219"
        transform="translate(-552.278 41.733)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_540"
        data-name="Line 540"
        x2="2.219"
        y2="0.053"
        transform="translate(-549.478 41.733)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_541"
        data-name="Line 541"
        x2="2.219"
        transform="translate(-546.678 41.786)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_542"
        data-name="Line 542"
        x2="2.219"
        transform="translate(-543.878 41.786)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_543"
        data-name="Line 543"
        x2="2.272"
        y2="0.053"
        transform="translate(-541.078 41.786)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_544"
        data-name="Line 544"
        x2="2.272"
        transform="translate(-538.277 41.839)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_545"
        data-name="Line 545"
        x2="2.272"
        transform="translate(-535.477 41.839)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_546"
        data-name="Line 546"
        x2="2.219"
        y2="0.053"
        transform="translate(-532.625 41.839)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_547"
        data-name="Line 547"
        x2="2.219"
        transform="translate(-529.825 41.892)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_548"
        data-name="Line 548"
        x2="2.219"
        transform="translate(-527.025 41.892)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_549"
        data-name="Line 549"
        x2="2.272"
        transform="translate(-524.225 41.945)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_550"
        data-name="Line 550"
        x2="2.272"
        transform="translate(-521.425 41.945)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_868"
        data-name="Path 868"
        d="M-518.625,41.945h2.642l.264-.106.317-.106.211-.211.211-.264.159-.264.106-.317.053-.264.053-1.321-.053-.317-.053-.317-.158-.264-.211-.264-.211-.211-.264-.158-.317-.106-.317-.053-2.43-.106"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_551"
        data-name="Line 551"
        x1="2.272"
        y1="0.053"
        transform="translate(-521.477 37.19)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_552"
        data-name="Line 552"
        x1="2.272"
        y1="0.106"
        transform="translate(-524.277 37.031)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_553"
        data-name="Line 553"
        x1="2.272"
        y1="0.106"
        transform="translate(-527.077 36.926)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_554"
        data-name="Line 554"
        x1="2.272"
        y1="0.106"
        transform="translate(-529.877 36.767)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_555"
        data-name="Line 555"
        x1="2.272"
        y1="0.106"
        transform="translate(-532.677 36.662)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_556"
        data-name="Line 556"
        x1="2.219"
        y1="0.106"
        transform="translate(-535.477 36.503)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_557"
        data-name="Line 557"
        x1="2.219"
        y1="0.106"
        transform="translate(-538.277 36.397)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_558"
        data-name="Line 558"
        x1="2.219"
        y1="0.106"
        transform="translate(-541.078 36.239)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_559"
        data-name="Line 559"
        x1="2.219"
        y1="0.106"
        transform="translate(-543.878 36.133)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_560"
        data-name="Line 560"
        x1="2.219"
        y1="0.106"
        transform="translate(-546.678 35.975)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_561"
        data-name="Line 561"
        x1="2.219"
        y1="0.106"
        transform="translate(-549.478 35.869)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_562"
        data-name="Line 562"
        x1="2.272"
        y1="0.106"
        transform="translate(-552.33 35.711)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_563"
        data-name="Line 563"
        x1="2.483"
        y1="0.106"
        transform="translate(-555.342 35.605)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_869"
        data-name="Path 869"
        d="M-556.451,34.443v.211l.106.211.106.211.106.158.158.158.211.106.211.053.211.053"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_564"
        data-name="Line 564"
        x1="48.974"
        y1="1.321"
        transform="translate(-563.742 38.405)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_565"
        data-name="Line 565"
        x1="0.358"
        y1="14.788"
        transform="translate(-556.545 31.167)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_566"
        data-name="Line 566"
        x1="0.37"
        y1="14.639"
        transform="translate(-553.281 31.114)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_870"
        data-name="Path 870"
        d="M-542.451,38.907a1.559,1.559,0,0,0-1.559-1.559,1.559,1.559,0,0,0-1.558,1.559,1.558,1.558,0,0,0,1.558,1.558,1.558,1.558,0,0,0,1.559-1.558"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_871"
        data-name="Path 871"
        d="M-492.051,38.748a1.559,1.559,0,0,0-1.558-1.558,1.559,1.559,0,0,0-1.559,1.558,1.559,1.559,0,0,0,1.559,1.559,1.559,1.559,0,0,0,1.558-1.559"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
    </g>
  </svg>
)
